import { queryOptions } from '@tanstack/react-query'
import { apiRequest } from '@/shared/api'
import { SearchResponseSchema } from '../model/types'

export const searchKeys = {
  results: (q: string, tag: string | null) => ['search', q, tag] as const,
}

// Готов, когда есть текстовый запрос (≥2 символов) ИЛИ тег.
const READY = (q: string, tag: string | null) => q.trim().length >= 2 || !!tag

export function searchQueryOptions({ q, tag }: { q: string; tag: string | null }) {
  return queryOptions({
    queryKey: searchKeys.results(q, tag),
    queryFn: async () => {
      const body = await apiRequest<{ data: unknown }>({
        method: 'GET',
        url: '/search',
        query: { q, ...(tag ? { tag } : {}) },
      })
      return SearchResponseSchema.parse(body.data)
    },
    enabled: READY(q, tag),
  })
}
